import React from "react";

const Weather = props => (
	<div className="weather__info">
	{!props.city ? <h2>
		This application was developed by <a href="https://bilis.gr">Thanos Bilis</a> using ReactJS and the OpenWeather API to fetch the weather data.
		<br/><br/>All rights deserved. ©2019.
	</h2> : ""}
	 {	
	 	props.city && props.country && <p className="weather__key"> Location: 
	 		<span className="weather__value"> { props.city }, { props.countryName }</span>
	 	</p> 
	 }
	 { 	
	 	props.temperature && <p className="weather__key"> Temperature: 
	 		<span className="weather__value"> { props.temperature } ºC	</span>
	 	</p> 
	 }
	 { 	
	 	props.humidity && <p className="weather__key"> Humidity: 
	 		<span className="weather__value"> { props.humidity }% </span>
	 	</p> 
	 }
	 { 	
	 	props.description && <p className="weather__key"> Conditions: 
	 		<span className="weather__value" style={{textTransform: "capitalize"}}> { props.description } </span>
	 </p> 
	 }
	 { 
	 	props.error && <p className="weather__error">{ props.error }</p>  
	 }
	</div>
);

export default Weather;